import React from 'react';
import { Search, Plus, Download } from 'lucide-react';
import AdvancedFilterPanel from '../AdvancedFilterPanel';
import { exportToCsv } from '../../utils/export';

const STATUS_CHIPS = ['Toutes', 'Provisoire', 'Validée', 'Payée', 'En retard', 'Avoirs'];

/**
 * Factures page — search + advanced filters + status chips + export + create button.
 * Status chip filter is a single-select (string) since invoices have a wider set
 * of states than the multi-select filter panel handles natively.
 */
export default function FacturesToolbar({
  search, setSearch,
  filter, setFilter,
  filterDateFrom, setFilterDateFrom,
  filterDateTo, setFilterDateTo,
  filterMinAmount, setFilterMinAmount,
  filterMaxAmount, setFilterMaxAmount,
  filteredCount, totalCount,
  filtered,
  onCreate,
}) {
  return (
    <div className="flex flex-col md:flex-row md:items-center gap-3 flex-wrap" data-testid="factures-toolbar">
      <div className="relative flex-1 max-w-md">
        <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-[#8E8FA5]" />
        <input
          data-testid="factures-search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Rechercher une facture…"
          className="w-full h-10 pl-10 pr-4 rounded-xl bg-white border border-[#EFF0F6] text-[13.5px] focus:border-[#C7D2FE] outline-none"
        />
      </div>
      <AdvancedFilterPanel
        testId="factures-filter"
        statuses={[]}
        selectedStatuses={new Set()}
        setSelectedStatuses={() => {}}
        dateFrom={filterDateFrom} setDateFrom={setFilterDateFrom}
        dateTo={filterDateTo} setDateTo={setFilterDateTo}
        minAmount={filterMinAmount} setMinAmount={setFilterMinAmount}
        maxAmount={filterMaxAmount} setMaxAmount={setFilterMaxAmount}
      />
      <div className="flex gap-2 flex-wrap">
        {STATUS_CHIPS.map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={`h-10 px-3.5 rounded-xl text-[12.5px] font-semibold transition-colors ${
              filter === f ? 'bg-[#EEF2FF] text-[#4F46E5]' : 'bg-white border border-[#EFF0F6] text-[#6B6C85] hover:border-[#C7D2FE]'
            }`}
          >
            {f}
          </button>
        ))}
      </div>
      <div className="text-[11.5px] text-[#8E8FA5] font-medium whitespace-nowrap">
        {filteredCount} / {totalCount}
      </div>
      <div className="flex gap-2 md:ml-auto">
        <button
          data-testid="factures-export-csv"
          onClick={() => exportToCsv('factures', filtered, ['id', 'client', 'amount', 'date', 'dueDate', 'status'])}
          className="h-10 px-3.5 rounded-xl bg-white border border-[#EFF0F6] text-[13px] font-medium text-[#4A4B63] flex items-center gap-2 hover:border-[#C7D2FE]"
        >
          <Download className="w-4 h-4" /> Exporter
        </button>
        <button
          data-testid="facture-create-btn"
          onClick={onCreate}
          className="h-10 px-4 rounded-xl brand-gradient text-white text-[13px] font-semibold flex items-center gap-2 shadow-sm hover:opacity-95"
        >
          <Plus className="w-4 h-4" /> Nouvelle facture
        </button>
      </div>
    </div>
  );
}
